import { render } from "./CalendarHomeNotificationModal.vue?vue&type=template&id=776edeea&scoped=true&ts=true"
import script from "./CalendarHomeNotificationModal.vue?vue&type=script&lang=ts"
export * from "./CalendarHomeNotificationModal.vue?vue&type=script&lang=ts"

import "./CalendarHomeNotificationModal.vue?vue&type=style&index=0&id=776edeea&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776edeea"]])

export default __exports__